module.exports = __webpack_public_path__ + "static/media/RitaSanosHover.5ec8aa5e.png";